module.exports = __webpack_public_path__ + "img/rs.0b9d64b.svg";